import { notification } from "antd";
import { field } from "vega";
import { alertsGroupTypes } from "../actions/alertsGroup";

const initialState = {
  userIds: [],
  created: false,
  isLoading: false,
  alertGroupCount: 0,
  dynamicComponent: null,
  shouldUpdate: false,
  data: {
    alertsGroup: [],
    locations: [],
    organizations: [],
  },
  currentModal: null,
  isPlaying: false,
  alertGroupDetail: {
    alertGroupName: "",
    description: "",
    userList: [],
  },
  alertUserDetail: {
    searchName: [],
    sortColumn: "name",
    filteredData: [],
    asc: true,
  },
  actionType: null,
  notification: null,
  filters: {
    isLoaded: false,
    name: "",
    description: "",
    sort: [{ field: "name", order: "asc" }],
    pagenumber: 0,
    limitnumber: 50,
  },
  error: null,
};

const alertsGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case alertsGroupTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case alertsGroupTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        alertGroupCount: action.payload.alertsGroup.totalCount || 0,
        data: {
          ...state.data,
          alertsGroup: action.payload.alertsGroup.data.map((obj) => {
            return {
              id: obj.id,
              name: obj?.name,
              description: obj?.description,
              users_count: obj?.users?.length,
              users: obj?.users,
            };
          }),
        },
        error: null,
      };
    case alertsGroupTypes.CREATE_SUCCESS:
      return {
        ...state,
        created: true,
      };
    case alertsGroupTypes.CREATE_ERROR:
      return {
        ...state,
        created: action.payload,
      };
    case alertsGroupTypes.SET_ALERT_GROUP_USER_IDS:
      return {
        ...state,
        userIds: action.payload.userIds,
      };
    case alertsGroupTypes.SET_ALERT_GROUP_DETAIL:
      return {
        ...state,
        alertGroupDetail: {
          ...state.alertGroupDetail,
          ...action.payload,
        },
      };
      case alertsGroupTypes.UPDATE_PAGINATION_REQUEST:
      return {
        ...state,
        shouldUpdate: action.payload.shouldUpdate,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };
    case alertsGroupTypes.SET_ALERT_USER_DETAIL:
      return {
        ...state,
        alertUserDetail: {
          ...state.alertUserDetail,
          ...action.payload,
        },
      };
    case alertsGroupTypes.SET_CURRENT_MODAL:
      return {
        ...state,
        currentModal: action.payload,
      };
    case alertsGroupTypes.SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case alertsGroupTypes.ACTION_TYPE:
      return {
        ...state,
        actionType: action.payload,
      };
    case alertsGroupTypes.UPDATE_FILTERS:
      if (!action.payload) return state;
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action?.payload,
          sort: action?.payload?.sort,
        },
      };
    case alertsGroupTypes.UPDATE_DYNAMIC_COMP:
      return {
        ...state,
        dynamicComponent: action.payload,
      };
    case alertsGroupTypes.SET_IS_PLAYING:
      return {
        ...state,
        isPlaying: action.payload,
      };
    case alertsGroupTypes.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case alertsGroupTypes.CLEAR_FILTER:
      return {
        ...state,
        filters: {
          isLoaded: false,
          name: "",
          description: "",
          sort: [{ field: "name", order: "asc" }],
          pagenumber: 0,
          limitnumber: 50,
        },
      };
    default:
      return state;
  }
};

export default alertsGroupReducer;
